import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import PageTitle from '../../../layouts/PageTitle';
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { useLoader } from '../../../../context/LoaderCotext';
import Swal from 'sweetalert2';
import { createFormAction } from '../../../../store/actions/FormsActions';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import ProjectCodesServices from '../../../../services/ProjectCodeService';
import { getMTEByEmail } from '../../../../services/MTEService';
import Select from 'react-select';
import { retrieveData, storeData } from '../../../../services/indexedDBUtils';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import moment from 'moment';
const FSRForm = ({ profile, employeeList }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { showLoader, hideLoader } = useLoader();
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [projectCodeList, setProjectCodeList] = useState([]);
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const { hasPermission } = useAuth();

  // Helper to strip time part
  const stripTime = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };
  const today = stripTime(new Date());

  // Validation Schema
  const validationSchema = Yup.object().shape({
    employee: Yup.object().required('Employee is required'),
    employeeNumber: Yup.string().required('Employee number is required'),
    employeeManager: Yup.string(),
    contract: Yup.string(),
    date: Yup.date().required('Date is required'),
    projects: Yup.string().required('Projects are required'),
    startDate: Yup.date()
      .required('Start date is required')
      .min(today, 'Start date cannot be in the past'),
    endDate: Yup.date(),
    employeeVisitorStatus: Yup.string(),
    preferredLocation: Yup.string(),
    telephone: Yup.boolean().default(false),
    furnitureNeeded: Yup.array(),
    afterHoursBuildingAccess: Yup.boolean(),
    SSAIKeyCardAccess: Yup.array(),
    specialAccess: Yup.array(),
    restRoomKey: Yup.string(),
    roomKeys: Yup.string(),
    notes: Yup.string(),
  });

  const [initialValues, setInitialValues] = useState({
    employee: null,
    employeeNumber: '',
    employeeManager: '',
    contract: '',
    date: new Date(),
    projects: '',
    startDate: null,
    endDate: null,
    employeeVisitorStatus: '',
    preferredLocation: '',
    telephone: false,
    furnitureNeeded: [],
    afterHoursBuildingAccess: false,
    SSAIKeyCardAccess: [],
    specialAccess: [],
    restRoomKey: '',
    roomKeys: '',
    notes: '',
    boxFolderId: '275393000439',
    boxFolderName: 'FSR-forms',
    timestamp: moment().unix(),
  });

  // Fetch employees on component mount
  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  useEffect(() => {
    setFolderAPISuccess(true);
  }, [cookieValue]);

  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  const handleEmployeeChange = async (selectedOption, setFieldValue, values) => {
    const getManager = await getMTEByEmail(selectedOption.email);
    if (
      typeof getManager != 'undefined' &&
      typeof getManager.manager != 'undefined' &&
      typeof getManager.contract != 'undefined' &&
      getManager.contract != '' &&
      getManager.contract.toLowerCase() != profile.contract.toLowerCase() &&
      profile.role.toLowerCase() !== 'admin'
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'You are not accosiated with selected employee contract, please select correct employee and contract',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`employeeManager`, '');
      setFieldValue(`contract`, '');
      return false;
    }
    setFieldValue(`employeeNumber`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`employeeManager`, getManager.manager || '');
    setFieldValue(`contract`, getManager.contract || '');
    ProjectCodesServices.getProjectCode(selectedOption.employeeNumber || '')
      .then((response) => {
        // Ensure response and data exist and are valid
        if (!response || !Array.isArray(response.data) || response.data.length === 0) {
          console.log('Invalid or empty project code data');
          setProjectCodeList([]);
          return; // Early return if no valid data
        }

        // Flatten and map project codes, with additional checks
        const codeList = response.data.flatMap(({ projectCodes }) =>
          Array.isArray(projectCodes) && projectCodes.length > 0
            ? projectCodes.map((code) => ({
                value: code,
                label: code,
              }))
            : []
        );

        // Update state with the final list of project codes, only if codeList is not empty
        if (codeList.length > 0) {
          setProjectCodeList(codeList);
        } else {
          console.log('No valid project codes found.');
        }
      })
      .catch((error) => {
        console.error('Error fetching project codes:', error);
      });
  };
  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }

    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
          manager: employee.manager,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'fsr-forms',
      contractor: 'ssai',
      dynamicFields: [
        {
          submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
          ...data,
        },
      ],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });

          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });

      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    if (typeof data != 'undefined') {
      const payloadForms = {
        ...data,
        employee: data.employee.value,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
      };
      handleUploadBatch(payloadForms);
    }
  };

  // Dropdown Options
  const furnitureOptions = ['Desk', 'Chair', 'File Cabinet', 'Bookcase', 'Lamp', 'Whiteboard'];
  const keyCardOptions = [
    { value: 'Building', label: 'Building' },
    { value: 'Lab', label: 'Lab' },
    { value: 'Server Room', label: 'Server Room' },
  ];
  const specialAccessOptions = [
    { value: 'Storage', label: 'Storage' },
    { value: 'Mechanical', label: 'Mechanical' },
    { value: 'Electrical', label: 'Electrical' },
  ];
  const restroomOptions = [
    { value: 'Men', label: 'Men' },
    { value: 'Women', label: 'Women' },
    { value: 'Unisex', label: 'Unisex' },
  ];

  return (
    <>
      <PageTitle pageTitle="Facilities Services Request Form" />
      <Card className="p-4">
        <div className="d-flex justify-content-end mb-2">
          <a
            className="text-primary"
            target="_blank"
            href="https://ssaihq.app.box.com/file/2049055633664"
          >
            Instruction to Submit the FSR Form
          </a>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue }) => (
            <FormikForm>
              {/* Row 1 */}
              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Employee Name <span className="text-danger">*</span>
                    </Form.Label>
                    <AsyncSelect
                      cacheOptions
                      defaultOptions={employeeList}
                      loadOptions={loadOptions}
                      placeholder="Search employee..."
                      value={values.employee}
                      onChange={(option) => {
                        setFieldValue('employee', option);
                        handleEmployeeChange(option, setFieldValue);
                      }}
                    />
                    <ErrorMessage name="employee" component="div" className="text-danger" />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Employee Number <span className="text-danger">*</span>
                    </Form.Label>
                    <Field
                      as={Form.Control}
                      name="employeeNumber"
                      readOnly
                      placeholder="Employee Number"
                    />
                    <ErrorMessage name="employeeNumber" component="div" className="text-danger" />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Employee Manager</Form.Label>
                    <Field as={Form.Control} name="employeeManager" readOnly />
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 2 */}
              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Date <span className="text-danger">*</span>
                    </Form.Label>
                    <DatePicker
                      selected={values.date}
                      onChange={(date) => setFieldValue('date', date)}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                      disabled
                    />
                    <ErrorMessage name="date" component="div" className="text-danger" />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Projects <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      name="projects"
                      options={projectCodeList}
                      value={projectCodeList.find((opt) => opt.value === values.projects) || null}
                      onChange={(opt) => setFieldValue('projects', opt?.value || '')}
                      placeholder="Select project"
                    />
                    <ErrorMessage name="projects" component="div" className="text-danger" />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Contract</Form.Label>
                    <Field as={Form.Control} name="contract" readOnly />
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 3 */}
              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Start Date <span className="text-danger">*</span>
                    </Form.Label>
                    <DatePicker
                      selected={values.startDate}
                      onChange={(date) => setFieldValue('startDate', date)}
                      className="form-control"
                      minDate={today}
                      placeholderText="Select start date"
                    />
                    <ErrorMessage name="startDate" component="div" className="text-danger" />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <DatePicker
                      selected={values.endDate}
                      onChange={(date) => setFieldValue('endDate', date)}
                      className="form-control"
                      minDate={values.startDate || today}
                      placeholderText="Select end date"
                    />
                    <ErrorMessage name="endDate" component="div" className="text-danger" />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Employee Visitor Status</Form.Label>

                    <Select
                      options={[
                        { label: 'Employee', value: 'Employee' },
                        { label: 'New hire', value: 'New hire' },
                      ]}
                      value={
                        [
                          { label: 'Employee', value: 'Employee' },
                          { label: 'New hire', value: 'New hire' },
                        ].find((o) => o.value === values.employeeVisitorStatus) || null
                      }
                      onChange={(opt) =>
                        setFieldValue('employeeVisitorStatus', opt ? opt.value : '')
                      }
                      placeholder="Employee Visitor Status"
                    />

                    <ErrorMessage
                      name="employeeVisitorStatus"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* === Facilities Options === */}
              <Row className="mb-4 align-items-center">
                <Col md={6}>
                  <Form.Check
                    id="telephoneRequired"
                    type="switch"
                    label="Telephone Required"
                    checked={values.telephone}
                    onChange={(e) => setFieldValue('telephone', e.target.checked)}
                  />
                  <Form.Check
                    id="afterHoursAccess"
                    type="switch"
                    label="After Hours Building Access"
                    checked={values.afterHoursBuildingAccess}
                    onChange={(e) => setFieldValue('afterHoursBuildingAccess', e.target.checked)}
                  />
                </Col>
                <Col md={6}>
                  <Form.Label className="mb-2">Furniture Needed</Form.Label>
                  <div className="fsr-checkbox-lg d-flex flex-wrap gap-3">
                    {furnitureOptions.map((item) => (
                      <Form.Check
                        key={item}
                        id={`furniture-${item.toLowerCase().replace(/\s+/g, '-')}`}
                        label={item}
                        type="checkbox"
                        className="me-3 mb-2"
                        checked={values.furnitureNeeded.includes(item)}
                        onChange={(e) => {
                          if (e.target.checked)
                            setFieldValue('furnitureNeeded', [...values.furnitureNeeded, item]);
                          else
                            setFieldValue(
                              'furnitureNeeded',
                              values.furnitureNeeded.filter((x) => x !== item)
                            );
                        }}
                      />
                    ))}
                  </div>
                </Col>
              </Row>
              {/* === Multi & Single Selects === */}
              <Row className="mb-4">
                <Col md={4}>
                  <Form.Label>SSAI Key Card Access</Form.Label>
                  <Select
                    isMulti
                    options={keyCardOptions}
                    value={
                      Array.isArray(values.SSAIKeyCardAccess)
                        ? values.SSAIKeyCardAccess.map((v) =>
                            keyCardOptions.find((o) => o.value === v)
                          ).filter(Boolean)
                        : []
                    }
                    onChange={(selected) =>
                      setFieldValue(
                        'SSAIKeyCardAccess',
                        selected ? selected.map((o) => o.value) : []
                      )
                    }
                    placeholder="Select access areas"
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Special Access</Form.Label>
                  <Select
                    isMulti
                    options={specialAccessOptions}
                    value={
                      Array.isArray(values.specialAccess)
                        ? values.specialAccess
                            .map((v) => specialAccessOptions.find((o) => o.value === v))
                            .filter(Boolean)
                        : []
                    }
                    onChange={(selected) =>
                      setFieldValue('specialAccess', selected ? selected.map((o) => o.value) : [])
                    }
                    placeholder="Select special access"
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Restroom Key</Form.Label>
                  <Select
                    options={restroomOptions}
                    value={restroomOptions.find((o) => o.value === values.restRoomKey) || null}
                    onChange={(opt) => setFieldValue('restRoomKey', opt ? opt.value : '')}
                    placeholder="Select restroom key"
                  />
                </Col>
              </Row>

              {/* === Room Keys & Notes === */}
              <Row className="mb-4">
                <Col md={6}>
                  <Form.Label>Room Keys</Form.Label>
                  <Field as={Form.Control} name="roomKeys" placeholder="Enter room keys info" />
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Preferred Location</Form.Label>
                    <Field
                      as={Form.Control}
                      name="preferredLocation"
                      placeholder="Preferred Location"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Notes</Form.Label>
                    <Field
                      as="textarea"
                      name="notes"
                      rows={3}
                      className="form-control"
                      placeholder="Additional notes"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                </Col>
              </Row>
            </FormikForm>
          )}
        </Formik>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(FSRForm);
